// extracted by mini-css-extract-plugin
module.exports = {"description":"productDescription_description__lGoDd","moreButton":"productDescription_moreButton__yLouo","gradient":"productDescription_gradient__m9Wv_"};